<template>
  <div v-if="ship" class="ship tw-flex tw-flex-nowrap tw-flex-col">
    <div class="ship__title tw-w-full tw-flex tw-justify-center tw-text-center tw-mb-4">
      <h1 class="tw-black">
        {{ ship.ShipName }}
      </h1>
    </div>
    <div class="ship__content tw-grid tw-grid-rows-2 tw-h-full md-max:tw-grid-cols-2 tw-px-0 sm:tw-px-4 xl:tw-px-16 2xl:tw-px-20">
      <div class="ship__content__image tw-grid-rows-1 md-max:tw-grid-cols-1 md-max:tw-pr-2">
        <img
            class="tw-w-full ship__img"
            :alt="ship.ShipName"
            :src="getImageSrc"
        >
      </div>
      <div
          class="ship__content__label tw-grid-rows-1 md-max:tw-grid-cols-1 md-max:tw-pl-2 tw-mt-6 md-max:tw-mt-0 tw-text-center tw-text-sm"
          v-html="ship.ShipSummary">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ship",

  props: {
    ship: {
      type: Object,
      default: () => {
      },
      required: false,
    },
    isDesktop: {
      type: Boolean,
      default: false,
      required: true
    },
    isTablet: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  computed: {
    getImageSrc() {
      if (this.isDesktop) {
        return this.ship?.Images?.Mobile || require('@/assets/images/ship-placeholder-mobile.jpg')
      } else if (this.isTablet) {
        return this.ship?.Images?.Desktop || require('@/assets/images/ship-placeholder-desktop.jpg')
      } else {
        return this.ship?.Images?.Mobile || require('@/assets/images/ship-placeholder-mobile.jpg')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "ShipTab";
</style>
